export default "__VITE_ASSET__db858ffb__"